export default __webpack_public_path__ + "static/asf_logo-82ded4d600cc31c325b2c8a505817da4.svg";